export const JUMBLEBERRY = 'https://jumbleberry.com';
export const TERMS_AND_CONDITIONS = 'https://jumbleberry.com/terms-and-conditions';
export const AFFILIATE_TERMS_AND_CONDITIONS = 'https://jumbleberry.com/affiliate-terms-and-conditions';
export const PRIVACY_POLICY = 'https://jumbleberry.com/privacy-policy';
export const ACCESSIBILITY_POLICY = 'https://jumbleberry.com/accessibility-policy';
export const AD_POLICY = 'https://jumbleberry.com/ad-policy';
